"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var VerificationEmailResendError = function VerificationEmailResendError() {
  return "\n  <p class=\"display-inline\">\n    <strong>" + _I18n.default.text('emailConfirmBar.resendErrorText') + "</strong>\n  </p>\n";
};

var _default = VerificationEmailResendError;
exports.default = _default;
module.exports = exports.default;